import SubmittedMessage from "./SubmittedMessage"

import styles from "../RereservationCompletePageV2.module.scss"

type Props = {
	email: string
	setEmail: (email: string) => void
	isEmailSubmitted: boolean
	isSubmittingEmail: boolean
	handleEmailSubmit: (e: React.FormEvent) => void
}

// 通常完了画面用メール登録セクション.
// design 参照: frontend/design/public/rereservation.pen Frame bou8Z 内 "Reminder Section" (id: 8aYHx)
const DefaultEmailSection = ({
	email,
	setEmail,
	isEmailSubmitted,
	isSubmittingEmail,
	handleEmailSubmit,
}: Props) => {
	let footer: JSX.Element
	if (isEmailSubmitted) {
		footer = <SubmittedMessage />
	} else {
		footer = (
			<div className={styles.email_description}>
				<p>※ メールアドレスを登録しない場合、予約確定メール、</p>
				<p>来店日前日リマインドメールの送付が行われません。</p>
			</div>
		)
	}

	let submitLabel: string
	if (isSubmittingEmail) {
		submitLabel = "送信中..."
	} else {
		submitLabel = "登録"
	}

	return (
		<div className={styles.email_reminder_section}>
			<h3 className={styles.title}>⚠️ご予約リマインド</h3>
			<form onSubmit={handleEmailSubmit} className={styles.email_form}>
				<div className={styles.email_description}>
					<p>予約日の前日にリマインドを受け取る場合は、</p>
					<p>メールアドレスを入力してください（任意）</p>
				</div>
				<div className={styles.email_input_wrapper}>
					<input
						type="email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						placeholder="example@email.com"
						className={styles.email_input}
						disabled={isSubmittingEmail}
					/>
					<button
						type="submit"
						className={styles.email_submit_button}
						disabled={isSubmittingEmail || !email}
					>
						{submitLabel}
					</button>
				</div>
				{footer}
			</form>
		</div>
	)
}

export default DefaultEmailSection
